import { withTimeout } from '@core/domain/utils/asyncResilience.ts';

const PROBE_PATH = '/manifest.webmanifest';
const PROBE_TIMEOUT_MS = 5000;

/** Best-effort same-origin fetch; stricter than `navigator.onLine` before catalog sync. */
export async function probeAppNetworkReachable(): Promise<boolean> {
  try {
    const url = new URL(PROBE_PATH, globalThis.location.origin).href;
    const res = await withTimeout(
      fetch(url, { method: 'GET', cache: 'no-store' }),
      PROBE_TIMEOUT_MS,
      'Sin conexión usable: tiempo de espera agotado.',
    );
    return res.ok;
  } catch {
    return false;
  }
}
